import { DamageType } from "./damageType";
import { Mob } from "./mob";
import type { PhysicalThing } from "./physicalThing";
import type { Thing } from "./thing";

export abstract class WeakMob extends Mob {
	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		super.onZeroHp(source, type);
		if (type !== DamageType.BUBBLE) return;

		const variant = this.createSolidifiedVariant();
		if (variant === null) return;

		variant.xy = this.xy;
		this.board!.addThing(variant);
	}

	abstract createSolidifiedVariant(): PhysicalThing | null;
}
